import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-feed-card',
  template: require('./feed-card.component.html'),
  styles: [require('./feed-card.component.css')]
})
export class FeedCardComponent implements OnInit {

  @Input() feed: any;

  constructor() { }

  ngOnInit() {
  }

  openLinkInBrowser() {
    window.open(this.feed.link);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/home/feed-card/feed-card.component.ts